




































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { InbProduct } from '@/models/InbProduct';
import http from '@/services/Http';

@Component
export default class ProductQuickReferenceGuide extends Vue {
    searchText: string = '';
    message: string = '';
    inbProducts: InbProduct[] = [] as InbProduct[];
    selectedInbProduct: InbProduct | null = null;
    loading: boolean = false;

    setSelectedInbProduct(inb: InbProduct) {
        this.selectedInbProduct = inb;
        const scrollToDetails = document.getElementById('InbProductDetails');
        if (!scrollToDetails) return;
        window.scrollTo({
            top: scrollToDetails.offsetTop - 20,
            behavior: 'smooth'
        });
    }

    private search() {
        this.inbProducts = [];
        if (this.searchText.length > 3) {
            this.loading = true;
            this.selectedInbProduct = null;
            this.message = '';
            const request = http.get(`/api/productquickreferenceguide?searchtext=${this.searchText}`);
            request
                .then((response: any) => {
                    this.loading = false;
                    const data = response.json();
                    data.then((reponse: InbProduct[]) => {
                        this.inbProducts = reponse as InbProduct[];
                        this.message = this.inbProducts.length === 0 ? 'Inga poster hittades' : '';
                    });
                })
                .catch(() => {
                    this.loading = false;
                    this.inbProducts = [];
                    this.message = 'Något gick fel - försök precisera din sökning';
                });
        } else {
            this.message = 'Ange minst 4 tecken';
        }
    }
}
